export const departmentsConfig = {
  api: () => '/departments',
  title: 'Department',
  isActionTab: true,
  modalTitle: (action) => `${action} ${departmentsConfig.title}`,
  getColumns: () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        isSearch: true,
      },
      {
        title: 'Created On',
        dataIndex: 'createdAt',
        key: 'createdAt',
        isSearch: true,
      },
    ];
  },
  getFormColumns: () => {
    return [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        isRequired: true,
        formClassName: 'col-8 pb-2',
      }
    ];
  },
  getData: () => ({}),
  actions: [
    { name: 'Add Department', isModal: true, settings: { type: 'primary' } },
    { name: 'Return', isBack: true, settings: { type: 'primary' } },
  ],
};
